import { createContext, useContext, useMemo, useState } from 'react';
import type { EventCategory } from '@/constants/events';

interface RecentUpdatesContextValue {
  title: string;
  setTitle(title: string): void;
  filter?: EventCategory;
  setFilter(filter?: EventCategory): void;
}

const RecentUpdatesContext = createContext<
  RecentUpdatesContextValue | undefined
>(undefined);

export function useRecentUpdatesContext() {
  const context = useContext(RecentUpdatesContext);
  if (!context) {
    throw new Error(
      'useRecentUpdatesContext must be used within RecentUpdatesProvider'
    );
  }
  return context;
}

interface RecentUpdatesProviderProps {
  children: React.ReactElement;
}
const RecentUpdatesProvider = (props: RecentUpdatesProviderProps) => {
  const [title, setTitle] = useState<string>('Recent updates');
  const [filter, setFilter] = useState<EventCategory | undefined>();

  const value = useMemo(
    () => ({
      title,
      filter,
      setFilter,
      setTitle,
    }),
    [title, setTitle, filter, setFilter]
  );

  return (
    <RecentUpdatesContext.Provider value={value}>
      {props.children}
    </RecentUpdatesContext.Provider>
  );
};
export default RecentUpdatesProvider;
